import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { Actions, Mutations } from '@/store/enums/StoreEnums'
import { HeaderInfos, UserResponse } from '@/types/api-response'
import ApiService from '@/services/ApiService'
import { AdmissibleInfos } from '@/types/layout'

@Module
export default class UserModule extends VuexModule {
  user: UserResponse = {
    userType: 'anon'
  }

  token = ''

  admissibleInfos: AdmissibleInfos = {}

  // noinspection JSUnusedGlobalSymbols
  get getToken () {
    return this.token
  }

  get getAdmissibleInfos () {
    return this.admissibleInfos
  }

  // noinspection JSUnusedGlobalSymbols
  get getUser () {
    return this.user
  }

  // noinspection JSUnusedGlobalSymbols
  get isLoggedIn () {
    return this.user.userType !== 'anon'
  }

  @Mutation
  [Mutations.LOGOUT] () {
    this.user = {
      userType: 'anon'
    }
    this.token = ''
  }

  @Mutation
  [Mutations.SAVE_USER] (payload: UserResponse) {
    this.user = payload
  }

  @Mutation
  [Mutations.SAVE_ADMISSIBLE_INFOS] (payload?: Partial<HeaderInfos>) {
    // Absent pour un dossier archivé : on vide l'en-tête plutôt que de garder celui de la session précédente (store persisté)
    this.admissibleInfos = {
      admFirstName: payload?.firstName,
      admLastName: payload?.lastName,
      formationYear: payload?.formationYear,
      formationEtape: payload?.formationEtape,
      formationLibelle: payload?.formationLibelle,
      contractType: payload?.contractType,
      school: payload?.school
    }
  }

  @Mutation
  [Mutations.SAVE_TOKEN] (token: string) {
    this.token = token
  }

  @Action
  [Actions.INIT_AUTHENTIFIED_AXIOS] (payload: string) {
    ApiService.vueInstance.axios.defaults.headers.common.Authorization = 'Bearer ' + payload
    this.context.commit(Mutations.SAVE_TOKEN, payload)
  }

  @Action
  async [Actions.FETCH_USER] () {
    try {
      const res = await ApiService.get<UserResponse>('/users/me')
      if (res?.data) {
        this.context.commit(Mutations.SAVE_USER, res.data)
        window._paq.push(['setUserId', res.data.mail])

        switch (res.data.userType) {
          case 'student':
            window._paq.push(['setCustomVariable', 1, 'student'])
            break
          case 'admissible':
            window._paq.push(['setCustomVariable', 1, 'student'])
            break
          case 'intervenant':
            window._paq.push(['setCustomVariable', 1, 'faculty'])
            break
          case 'staff':
            window._paq.push(['setCustomVariable', 1, 'staff'])
            break
          case 'admin':
            window._paq.push(['setCustomVariable', 1, 'staff'])
            break
          case 'parent':
            window._paq.push(['setCustomVariable', 1, 'student_advisor'])
            break
          case 'company':
            window._paq.push(['setCustomVariable', 1, 'company'])
            break
          default:
            window._paq.push(['setCustomVariable', 1, 'other'])
        }
        window._paq.push(['trackPageView'])
      }
    } catch (e) {}
  }

  @Action
  async [Actions.REFRESH_USER] () {
    try {
      await ApiService.get<UserResponse>('/admissibles/refresh_token')
    } catch (e) {}
  }
}
